import de from "ressources/labels/de.json"

function get(identifier) {
	return de[identifier] ?? identifier
}

export const label = {
	get
}


